import { render, staticRenderFns } from "./updatescreen.vue?vue&type=template&id=3c83ed54&scoped=true"
import script from "./updatescreen.vue?vue&type=script&lang=js"
export * from "./updatescreen.vue?vue&type=script&lang=js"
import style0 from "./updatescreen.vue?vue&type=style&index=0&id=3c83ed54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c83ed54",
  null
  
)

/* custom blocks */
import block0 from "./updatescreen.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports